<div class="container-fluid widget-wrapper">
  <div class="row widget-header">
    <div class="col-lg-12">
      <h2>
        Cookie Banner
        <a class="btn btn-link help-icon p-0 invisible" data-placement="top" data-toggle="tooltip" enTooltip title="">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12">
      <domain-cookie-banner [data]="data"></domain-cookie-banner>
    </div>
  </div>
</div>